import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { StripeProvider } from 'react-stripe-elements';

const STRIPE_SCRIPT_URL = 'https://js.stripe.com/v3/';

const StripeProviderWrapper = ({ children }) => {
  const [isStripeLoaded, setStripeLoaded] = useState(!!window.Stripe);

  useEffect(() => {
    if (!isStripeLoaded) {
      const script = document.createElement('script');
      script.src = STRIPE_SCRIPT_URL;
      script.async = true;

      const onScriptLoad = () => {
        setStripeLoaded(true);
      };

      script.onload = onScriptLoad;
      document.head.appendChild(script);

      return () => {
        if (isStripeLoaded) {
          document.head.removeChild(script);
        }
      };
    }
  }, [isStripeLoaded]);

  return isStripeLoaded ? (
    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>{children}</StripeProvider>
  ) : null;
};

StripeProviderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StripeProviderWrapper;
